// Imported from the enum's own file, NOT the `lib/modules` barrel. The barrel
// re-exports `use-module-routes`, which pulls in the user-state provider and
// the generated GraphQL types — a cycle that leaves the enum undefined at
// import time for anything that reaches this module first. Same bite as
// `features/wild-game/use-wild-game.ts`.
import { ModuleId } from 'lib/modules/module-id.enum';

import { useUserState } from 'providers';

/**
 * Whether job tags are switched on for the processor the current user is
 * acting as.
 *
 * The ONE place the web app asks this question, so "job tags are off" cannot
 * mean different things in different components.
 *
 * Reads `isActiveModule` — which checks the vendor's module rows directly —
 * and NOT `useIsModuleActive`, which answers from the module REGISTRY. The
 * registry only knows module types that registered a `BaseModule`; job tags
 * own no routes and no module class, so that hook would report false for
 * every vendor no matter how the flag is set.
 *
 * Fails CLOSED. An unloaded user, no active vendor, or no module row all mean
 * "off", so tags never flash into view while state settles and then vanish.
 *
 * This is presentation only. The authoritative gate is server-side in
 * `graphql/authorizers/jobTagsModuleOnly` and the job create/update paths — a
 * hidden picker is not a permission.
 * @returns true when the processor has the JOB_TAGS module active.
 */
export function useJobTagsEnabled(): boolean {
  const { isActiveModule } = useUserState();
  return isActiveModule(ModuleId.JOB_TAGS);
}
